export default {
    'gray-5': '#FAFBFC',
    'gray-10': '#F4F6F8',
    'gray-15': '#EBEEF0',
    'gray-20': '#DFE3E5',
    'gray-25': '#D4D8DB',
    'gray-30': '#BDC2C7',
    'gray-35': '#a7aeb5',
    'gray-40': '#949AA1',
    'gray-50': '#6E767D',
    'gray-60': '#4F5861',
    'gray-70': '#3C464F',
    'gray-80': '#2A333D',
    'gray-90': '#1C232B',
    'gray-100': '#080A0D',

    'lightblue-50': '#00adfd',
    'lightblue-80': '#29394d',
    'lightblue-90': '#112133',

    'blue-5': '#F0F5FC',
    'blue-10': '#DEE9F8',
    'blue-20': '#B9D0F2',
    'blue-30': '#93B7E8',
    'blue-35': '#739FE0',
    'blue-40': '#4C87D7',
    'blue-50': '#1964CB',
    'blue-60': '#0054C6',
    'blue-70': '#00419B',
    'blue-80': '#003879',
    'blue-90': '#002659',
    'blue-95': '#051F40',
    'blue-100': '#04172F',

    'red-10': '#F7E2E1',
    'red-20': '#EDBEBD',
    'red-30': '#E49A99',
    'red-40': '#DA7674',
    'red-50': '#D15250',
    'red-60': '#C72E2C',

    'yellow-80': '#FD7C00',
    yellow: '#FDA200',

    white: '#FFFFFF',

    black: '#000000',
    'black-100': '#080A0D',

    'orange-10': '#FFF1E5',
    'orange-20': '#FFD8B5',
    'orange-50': '#E16F24',
};
